(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abm-faq-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', (event) => {
    const opened = event.target;
    if (!(opened instanceof HTMLDetailsElement) || !opened.open || !opened.classList.contains('abmf__item')) return;
    const group = opened.closest('.abmf__questions');
    if (!group) return;
    group.querySelectorAll('details.abmf__item[open]').forEach(item => {
      if (item !== opened) item.open = false;
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abm-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('abm-faq-accordion')) {
 customElements.define('abm-faq-accordion',class extends HTMLElement {
  connectedCallback() {
   if(this.controller)return;
   this.controller=new AbortController();this.animations=new Map();
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');
   this.addEventListener('click',event=>{
    const summary=event.target.closest('summary');if(!summary||!this.contains(summary))return;
    event.preventDefault();const item=summary.parentElement;
    const opening=this.animations.has(item)?!this.animations.get(item).opening:!item.open;
    if(opening&&this.dataset.single==='true')this.querySelectorAll('details').forEach(other=>{if(other!==item&&other.open)this.toggleItem(other,false);});
    this.toggleItem(item,opening);
   },{signal:this.controller.signal});
   document.addEventListener('shopify:block:select',event=>{
    const item=event.target.closest('details');if(item&&this.contains(item))this.toggleItem(item,true);
   },{signal:this.controller.signal});
  }
  toggleItem(item,opening) {
   const start=item.getBoundingClientRect().height;
   this.animations.get(item)?.animation.cancel();
   this.animations.delete(item);
   item.style.height='';item.style.overflow='';
   if(this.motion.matches||!item.animate){item.open=opening;return;}
   item.open=true;
   const end=opening?item.getBoundingClientRect().height:item.querySelector('summary').getBoundingClientRect().height+2;
   item.style.overflow='hidden';
   const animation=item.animate([{height:start+'px'},{height:end+'px'}],{duration:420,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'});
   this.animations.set(item,{animation,opening});
   animation.finished.then(()=>{
    if(this.animations.get(item)?.animation!==animation)return;
    item.open=opening;animation.cancel();item.style.overflow='';this.animations.delete(item);
   }).catch(()=>{});
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;this.animations?.forEach(({animation},item)=>{animation.cancel();item.style.overflow='';});this.animations?.clear();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abm-featured-products"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('abm-featured-cart')) {

  customElements.define('abm-featured-cart', class extends HTMLElement {

    connectedCallback() {

      if (this.controller) return;

      this.controller = new AbortController();

      this.addEventListener('submit', (event) => this.add(event), { signal: this.controller.signal });
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-abm-choose]');
        if (trigger) {
          const dialog = document.getElementById(trigger.dataset.abmChoose);
          if (!dialog || !this.contains(dialog)) return;
          this.closeQuick();
          this.quickDialog = dialog;
          this.quickTrigger = trigger;
          this.previousOverflow = document.documentElement.style.overflow;
          dialog.addEventListener('close', () => { if (this.quickDialog === dialog && !dialog.open) this.cleanupQuick(); }, {once:true});
          try { dialog.showModal(); document.documentElement.style.overflow = 'hidden'; }
          catch { this.cleanupQuick(); }
          return;
        }
        if (event.target.closest('[data-abm-close]')) { this.closeQuick(); return; }
        if (event.target === this.quickDialog) {
          const rect = this.quickDialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeQuick();
        }
      }, {signal:this.controller.signal});
      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-abm-variant]')) return;
        const select = event.target;
        const option = select.selectedOptions[0];
        const dialog = select.closest('dialog');
        if (!option || !dialog) return;
        dialog.querySelector('[data-abm-quick-price]').textContent = option.dataset.price;
        const compare = dialog.querySelector('[data-abm-quick-compare]');
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
        const image = dialog.querySelector('.abm-featured__dialog-image');
        if (image && option.dataset.image) {image.removeAttribute('srcset');image.src=option.dataset.image;}
        const quantity = select.form.querySelector('[name="quantity"]');
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        select.form.querySelector('[data-abm-cart-message]').hidden = true;
      }, {signal:this.controller.signal});
      window.addEventListener('pagehide', () => this.closeQuick(), {signal:this.controller.signal});

    }

    cleanupQuick() {
      if (this.previousOverflow !== undefined) document.documentElement.style.overflow = this.previousOverflow;
      this.previousOverflow = undefined;
      this.quickDialog = null;
      this.quickTrigger?.focus({preventScroll:true});
      this.quickTrigger = null;
    }
    closeQuick() {
      const dialog = this.quickDialog;
      if (dialog?.open) dialog.close();
      this.cleanupQuick();
    }
    disconnectedCallback() { this.closeQuick(); this.controller?.abort(); this.controller = null; }

    async add(event) {

      const form = event.target.closest('.abm-featured__form');

      if (!form) return;

      event.preventDefault();

      if (window.abmFeaturedCartBusy) return;

      const button = form.querySelector('[name="add"]');

      const message = form.querySelector('[data-abm-cart-message]');

      const label = button.innerHTML;
      const sourceDialog = form.closest("dialog");

      let added = false;

      let activeDrawer;

      let drawerStatus;

      window.abmFeaturedCartBusy = true;

      button.disabled = true;

      button.setAttribute('aria-busy', 'true');

      button.textContent = 'Adding…';

      message.hidden = true;

      const root = window.Shopify?.routes?.root || '/';

      try {

        let drawer = document.querySelector('theme-drawer#cart-drawer') || document.querySelector('cart-drawer-component');

        if (!drawer) throw new Error('Please enable Drawer under Theme settings → Cart, then try again.');

        drawer.querySelectorAll('.abm-featured__drawer-status').forEach((status) => status.remove());

        activeDrawer = drawer;

        drawer.setAttribute('aria-busy', 'true');

        drawerStatus = document.createElement('p');

        drawerStatus.className = 'abm-featured__drawer-status';

        drawerStatus.setAttribute('role', 'status');

        drawerStatus.textContent = 'Adding item to your cart…';

        const statusContainer = drawer.querySelector('.cart-drawer__inner') || drawer.querySelector('dialog') || drawer;

        statusContainer.prepend(drawerStatus);

        const body = new FormData(form);

        body.delete('return_to');

        const response = await fetch(root + 'cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });

        const result = await response.json();

        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');

        added = true;

        // Read the actual storefront page, preserving the same render context and styles

        // as opening the cart from the header. Do not transplant stripped section HTML.

        const pageURL = new URL(window.location.href);

        pageURL.searchParams.delete('sections');

        pageURL.searchParams.delete('section_id');

        const pageResponse = await fetch(pageURL, { cache: 'no-store', headers: { Accept: 'text/html' } });

        if (!pageResponse.ok) throw new Error('Drawer refresh failed.');

        const parsed = new DOMParser().parseFromString(await pageResponse.text(), 'text/html');

        const styleLoads = [];

        parsed.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {

          if (Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some((existing) => existing.href === link.href)) return;

          const copy = link.cloneNode(true);

          styleLoads.push(new Promise((resolve) => {

            copy.onload = resolve;

            copy.onerror = resolve;

            document.head.appendChild(copy);

          }));

        });

        parsed.querySelectorAll('style').forEach((style) => {

          if (!Array.from(document.querySelectorAll('style')).some((existing) => existing.textContent === style.textContent)) {

            document.head.appendChild(style.cloneNode(true));

          }

        });

        await Promise.all(styleLoads);

        const fresh = parsed.querySelector('theme-drawer#cart-drawer') || parsed.querySelector('cart-drawer-component');

        if (!fresh) throw new Error('Drawer refresh failed.');

        // Preserve the live drawer, dialog, theme classes and layout attributes.

        // Only update its cart content; replacing the outer drawer loses live theme state.

        const liveInner = drawer.querySelector('.cart-drawer__inner');

        const freshInner = fresh.querySelector('.cart-drawer__inner');

        if (liveInner && freshInner) {

          liveInner.className = freshInner.className;

          liveInner.replaceChildren(...Array.from(freshInner.childNodes));

        } else {

          const liveItems = drawer.querySelector('cart-items-component');

          const freshItems = fresh.querySelector('cart-items-component');

          if (!liveItems || !freshItems) throw new Error('Drawer content could not refresh.');

          liveItems.replaceWith(freshItems);

          const liveSummary = drawer.querySelector('.cart-drawer__summary');

          const freshSummary = fresh.querySelector('.cart-drawer__summary');

          if (liveSummary && freshSummary) liveSummary.replaceWith(freshSummary);

          const liveHeading = drawer.querySelector('.cart-drawer__heading');

          const freshHeading = fresh.querySelector('.cart-drawer__heading');

          if (liveHeading && freshHeading) liveHeading.replaceChildren(...Array.from(freshHeading.childNodes));

          drawer.querySelectorAll('.cart-drawer--empty').forEach((node) => node.classList.remove('cart-drawer--empty'));

        }

        document.querySelectorAll('cart-icon').forEach((icon, index) => {

          const replacement = parsed.querySelectorAll('cart-icon')[index];

          if (replacement) icon.replaceWith(replacement);

        });

        if (sourceDialog?.open) {
          sourceDialog.close();
          if (this.quickDialog === sourceDialog) this.cleanupQuick();
        }
        // Open only after Shopify confirms the add and the visible cart is refreshed.

        if (typeof drawer.open === 'function') drawer.open();

        else if (typeof drawer.showDialog === 'function') drawer.showDialog();

        else {

          const dialog = drawer.querySelector('dialog') || drawer.closest('dialog');

          if (!dialog) throw new Error('Cart drawer could not be opened.');

          if (!dialog.open) dialog.showModal();

        }

      } catch (error) {

        message.textContent = added ? 'Item added. Please use the cart icon to view your cart; the drawer could not refresh.' : (error.message || 'Unable to add this item. Please try again.');

        message.hidden = false;

        if (drawerStatus) {

          drawerStatus.textContent = message.textContent;

          drawerStatus.setAttribute('role', 'alert');

          if (!drawerStatus.isConnected && activeDrawer) {

            (activeDrawer.querySelector('.cart-drawer__inner') || activeDrawer).prepend(drawerStatus);

          }

        }

      } finally {

        activeDrawer?.removeAttribute('aria-busy');

        if (drawerStatus?.getAttribute('role') !== 'alert') drawerStatus?.remove();

        button.innerHTML = label;

        button.disabled = false;

        button.removeAttribute('aria-busy');

        window.abmFeaturedCartBusy = false;

      }

    }

  });

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abm-product-details"] && !Shopify.designMode) return;
  try {
    
(function(){
 function init(root){
  root.querySelectorAll('[data-abm-product-tabs]').forEach(function(widget){
   if(widget.dataset.ready) return;
   widget.dataset.ready='true';
   var media=window.matchMedia('(max-width:749px)');
   var nav=widget.querySelector('[role="tablist"]');
   var tabs=Array.from(widget.querySelectorAll('.abm-pi__tab'));
   var panels=Array.from(widget.querySelectorAll('.abm-pi__panel'));
   var toggles=Array.from(widget.querySelectorAll('.abm-pi__mobile-toggle'));
   var active=0;
   function sync(){
    var mobile=media.matches;
    if(mobile) nav.removeAttribute('role'); else nav.setAttribute('role','tablist');
    panels.forEach(function(panel,index){
     panel.hidden=!mobile && index!==active;
     if(mobile){
      panel.removeAttribute('role');panel.removeAttribute('tabindex');panel.removeAttribute('aria-labelledby');
     }else{
      panel.setAttribute('role','tabpanel');panel.setAttribute('tabindex','0');panel.setAttribute('aria-labelledby',tabs[index].id);
     }
    });
    tabs.forEach(function(tab,index){tab.setAttribute('aria-selected',String(index===active));tab.tabIndex=index===active?0:-1;});
   }
   function select(index,focus){active=index;sync();if(focus)tabs[index].focus();}
   tabs.forEach(function(tab,index){
    tab.addEventListener('click',function(){select(index,false);});
    tab.addEventListener('keydown',function(e){
     var next;
     if(e.key==='ArrowDown'||e.key==='ArrowRight')next=(index+1)%tabs.length;
     if(e.key==='ArrowUp'||e.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;
     if(e.key==='Home')next=0;
     if(e.key==='End')next=tabs.length-1;
     if(next!==undefined){e.preventDefault();select(next,true);}
    });
   });
   toggles.forEach(function(toggle,index){
    toggle.addEventListener('click',function(){
     var open=toggle.getAttribute('aria-expanded')!=='true';
     toggles.forEach(function(other){other.setAttribute('aria-expanded','false');});
     toggle.setAttribute('aria-expanded',String(open));
     if(open)active=index;
     sync();
    });
   });
   if(media.addEventListener)media.addEventListener('change',sync);else media.addListener(sync);
   sync();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
 document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abm-whatsapp-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('abm-chat-reviews')) {
  customElements.define('abm-chat-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.abm-chats__track');
      this.cards = Array.from(this.querySelectorAll('[data-chat-card]'));
      this.controls = this.querySelector('.abm-chats__controls');
      this.prev = this.querySelector('[data-chat-prev]');
      this.next = this.querySelector('[data-chat-next]');
      this.dots = this.querySelector('.abm-chats__dots');
      this.cards.forEach((card, index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'abm-chats__dot';
        button.setAttribute('aria-label', `Show customer screenshot ${index + 1}`);
        button.addEventListener('click', () => this.go(index), { signal });
        this.dots.append(button);
      });
      this.prev.addEventListener('click', () => this.go(this.current - 1), { signal });
      this.next.addEventListener('click', () => this.go(this.current + 1), { signal });
      this.track.addEventListener('scroll', () => {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { passive: true, signal });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.go(this.current + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      this.track.addEventListener('contextmenu', (event) => {
        if (event.target.closest('[data-chat-card]')) event.preventDefault();
      }, { signal });
      this.track.addEventListener('dragstart', (event) => {
        if (event.target.closest('[data-chat-card]')) event.preventDefault();
      }, { signal });
      this.observer = new ResizeObserver(() => this.update()); this.observer.observe(this.track);
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.cards.findIndex(card => card.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.go(index);
      }, { signal });
      this.update();
    }
    position(card) { return card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft; }
    go(index) {
      if (!this.cards.length) return;
      index = Math.max(0, Math.min(this.cards.length - 1, index));
      this.track.scrollTo({ left: this.position(this.cards[index]), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    update() {
      if (!this.cards.length) { this.current = 0; return; }
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const overflow = max > 2;
      this.controls.hidden = !overflow; this.dots.hidden = !overflow; this.track.dataset.overflow = String(overflow);
      let closest = Infinity; this.current = 0;
      this.cards.forEach((card, index) => {
        const distance = Math.abs(this.position(card) - this.track.scrollLeft);
        if (distance < closest) { closest = distance; this.current = index; }
      });
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      Array.from(this.dots.children).forEach((dot, index) => {
        const target = this.position(this.cards[index]);
        dot.hidden = target > max + 2 && index !== this.current;
        dot.setAttribute('aria-current', index === this.current ? 'true' : 'false');
      });
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null; this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.dots?.replaceChildren();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
